import { IOrder } from '@/store/ducks/order/types';

export const useLocalOrder: () => IOrder = () => {
  const storedOrder = localStorage.getItem('order');
  return storedOrder ? JSON.parse(storedOrder) : null;
};
